interface Input {
  first_name: string;
  insertions: string | null;
  last_name: string;
}

const formatFullDriverName = (input: Input) => {
  if (!input) {
    return '';
  }

  let name = input.first_name;

  if (input.insertions) {
    name += ' ';
    name += input.insertions;
  }

  name += ' ';
  name += input.last_name;

  return name;
};

export { formatFullDriverName };
